import { trackEvent } from '@/components/providers/AnalyticsProvider/AnalyticsProvider';
import { RecWizard } from '@/types/recWizard';
import { WEB_URL } from '@petplate/settings';
import { LocalStorageService, REC_WIZARD_KEY } from '@petplate/ui/lib/storage';
import qs from 'qs-lite';
import { redirect } from 'react-router-dom';
import { markWizardComplete } from '../utils/recWizard';
import { isSignedIn, sdk } from '../utils/sdk';

const next = `${WEB_URL}/account`;

// NOTE: To be used in a react-router loader only
export const handleCheckoutConfirmation = async ({ request }: { request: Request }) => {
  const url = new URL(request.url);
  const guestToken = url.searchParams.get('guestToken');
  const email = url.searchParams.get('email');
  const expressPlanSku = url.searchParams.get('expressPlanSku');
  const wizardId = url.searchParams.get('wizardId');
  let userExists = false;

  // This means someone came here manually without finishing the subflow
  if (!guestToken || !email || !wizardId) {
    return redirect('/subscription');
  }

  // AIDEV-NOTE: fire confirmation event once we know the user actually finished checkout
  // (loader-only route — no component lifecycle, so we track here before redirect)
  trackEvent('/subscription/confirmation', { wizardId, email, expressPlanSku });

  // Set the wizard as complete to avoid reusing it later
  try {
    const wizard = (LocalStorageService.get(REC_WIZARD_KEY) || {}) as Partial<RecWizard>;
    if (wizard.id === wizardId) {
      markWizardComplete();
    }
  } catch {
    // ignore and skip marking wizard complete
  }

  // if user signed in, redirect to the order confirmation page
  if (isSignedIn()) {
    return redirect(next);
  }

  // check for existence of user in our system
  if (email) {
    const existenceResp = await sdk.CheckUserExistence({ email });
    userExists = existenceResp?.userExists;
  }

  // forward params needed to associate user with order
  const redirectParams = qs.stringify({ guestToken, email, wizardId, next, expressPlanSku });

  // redirect user to sign-in if they have an account
  if (userExists) {
    return redirect(`${WEB_URL}/login?${redirectParams}`);
  }

  // otherwise redirect to sign-up
  return redirect(`${WEB_URL}/sign-up?${redirectParams}`);
};
